import { ApiClientError, ApiNetworkError } from "../api/client.js";

export function loginFailureMessage(cause: unknown): string {
  if (cause instanceof ApiNetworkError) {
    return "网络连接异常，未能连接登录服务。请检查网络后重试。";
  }
  if (cause instanceof ApiClientError) {
    if (cause.status === 401) {
      // Keep unknown, disabled and locked accounts indistinguishable.
      return "用户名或密码不正确，请检查后重试。";
    }
    if (cause.status === 400 && cause.code === "VALIDATION_ERROR") {
      return "用户名或密码格式不正确，请检查输入后重试。";
    }
    if (cause.status === 429) {
      return "登录尝试过于频繁，请稍后再试。";
    }
    if (cause.status === 403) {
      return "登录请求被拒绝，请刷新页面后重试；仍无法登录请联系管理员。";
    }
    if (cause.status >= 500 && cause.status <= 599) {
      return "登录服务暂时不可用，请稍后重试；持续失败请联系管理员。";
    }
  }
  // Do not expose raw messages, credentials, request bodies or upstream details.
  return "登录未能完成，请刷新页面后重试；持续失败请联系管理员。";
}
